<div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayout.md="column" fxLayoutGap="25px" fxLayoutGap.xs="0" fxLayoutGap.sm="0" fxLayoutGap.md="0">

    <div fxFlex="66.666666%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%" class="col">

        <!-- <app-ecommerce-stats></app-ecommerce-stats> -->

        <app-audience-overview></app-audience-overview>

        <!-- <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutGap="25px" fxLayoutGap.xs="0" fxLayoutGap.sm="0">
            <div fxFlex="66.666666%" fxFlex.xs="100%" fxFlex.sm="100%" class="col">

                <app-visits-by-day></app-visits-by-day>

            </div>
            <div fxFlex="33.333333%" fxFlex.xs="100%" fxFlex.sm="100%" class="col">

                <app-ecommerce-impressions></app-ecommerce-impressions>

                <app-ecommerce-activity-timeline></app-ecommerce-activity-timeline>

            </div>
        </div> -->

        <!-- <app-revenue-status></app-revenue-status> -->

    </div>

    <div fxFlex="33.333333%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%" class="col">

        <app-ecommerce-ratings></app-ecommerce-ratings>

        <!-- <app-live-visits-on-our-site></app-live-visits-on-our-site> -->

        <!-- <app-sales-by-locations></app-sales-by-locations>

        <app-new-customers></app-new-customers> -->

    </div>

</div>

<!-- <app-recent-orders></app-recent-orders> -->

<div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayout.md="column" fxLayoutGap="25px" fxLayoutGap.xs="0" fxLayoutGap.sm="0" fxLayoutGap.md="0">

    <app-team-members-list fxFlex="66.666666%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%" class="col"></app-team-members-list>

    <app-best-selling-products fxFlex="33.333333%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%" class="col"></app-best-selling-products>

</div>